import { Controller } from "@hotwired/stimulus"

// Client-side filter for a section's table: typing in the search input hides
// rows whose text doesn't match. Shows an "empty" row when nothing matches.
// Wire-up:
//   data-controller="table-search"
//   <input data-table-search-target="input" data-action="input->table-search#filter">
//   <tr data-table-search-target="row"> … per data row
//   <tr data-table-search-target="empty" hidden> … optional "no matches" row
// A row may set `data-search="…"` to scope matching to specific text (e.g. just
// the name) instead of the whole row — useful when action-button labels would
// otherwise pollute the match. Falls back to the row's full text.
export default class extends Controller {
  static targets = ["input", "row", "empty"]

  filter() {
    const q = this.inputTarget.value.trim().toLowerCase()
    let visible = 0

    this.rowTargets.forEach((row) => {
      const haystack = (row.dataset.search ?? row.textContent).toLowerCase()
      const match = q === "" || haystack.includes(q)
      row.hidden = !match
      if (match) visible += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
  }
}
